import React from "react";
import ReactDOM from "react-dom";

import "./index.css";
import App from "./App";

import { Provider } from "mobx-react";

import { Store } from "./store";

import "@ionic/core/css/core.css";
import "@ionic/core/css/ionic.bundle.css";

import * as serviceWorker from "./serviceWorker";

if (typeof process === "undefined") {
  window.process = { env: {} };
}

const store = new Store();

ReactDOM.render(
  <Provider store={store}>
    <App />
  </Provider>,
  document.getElementById("root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
